import { getCustomerJourneyTagsAsString } from 'models/enums/customer-journey-tag';

interface RobotTag {
  id: string;
  dateCreated: string;
  tag: string;
  robot: string;
}

export enum TagType {
  CUSTOM,
  CUSTOMER_JOURNEY,
}

export default RobotTag;

export const getExistingMutuallyExclusiveTag = (tags: RobotTag[], newTag: string) => {
  const customerJourneyTags = getCustomerJourneyTagsAsString();

  if (customerJourneyTags.includes(newTag)) {
    // If the updating tag is a customer journey tag return the existing customer journey tag
    return tags.find((t) => customerJourneyTags.includes(t.tag)) ?? null;
  }

  return null;
};
